import React from 'react';

const Guarantee = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M11.3999 11.9114C11.3232 11.9789 11.2107 11.9814 11.1316 11.9181L8.18407 9.55056L6.7749 11.3047L9.7224 13.6722C10.1749 14.0356 10.7182 14.2156 11.2616 14.2156C11.8441 14.2156 12.4266 14.0081 12.8916 13.5956L17.9749 9.09139L16.4824 7.40723L11.3991 11.9114H11.3999Z'
        fill='#200000'
      />
      <path
        d='M20.9025 2.30373C20.3642 1.83706 19.65 1.62706 18.945 1.72789L4.36083 3.81123C3.1575 3.98373 2.25 5.02956 2.25 6.24456V12.9037C2.25 15.3262 3.46083 17.5896 5.41 18.8112L10.6942 22.1237C11.0908 22.3721 11.545 22.4971 12 22.4971C12.4542 22.4971 12.9092 22.3729 13.3058 22.1237L18.59 18.8112C20.5392 17.5887 21.75 15.3254 21.75 12.9037V4.16123C21.75 3.44789 21.4408 2.77039 20.9025 2.30373ZM19.5 12.9037C19.5 14.5571 18.6933 16.0904 17.395 16.9046L12.1108 20.2171C12.0425 20.2596 11.9575 20.2596 11.8892 20.2171L6.605 16.9046C5.30667 16.0912 4.5 14.5579 4.5 12.9037V6.24456C4.5 6.13956 4.57583 6.05289 4.67917 6.03789L19.2625 3.95456C19.2733 3.95289 19.2842 3.95206 19.2942 3.95206C19.355 3.95206 19.4 3.97873 19.4283 4.00289C19.4608 4.03123 19.5 4.08206 19.5 4.16039V12.9029V12.9037Z'
        fill='#200000'
      />
    </svg>
  );
};

export default Guarantee;
